import { Component, Input, AfterViewInit } from '@angular/core';
import * as Chartist from 'chartist';
import 'chartist-plugin-tooltips';
import { Observable } from 'rxjs';
import { ParameterData } from '../_helpers/parameter.data';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DataService } from '../_helpers/dataservice.service'
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'chartistinv',
  template: `
          <div id="chartinv" ></div>
`,
  styleUrls: ['../../assets/css/chartist-custom.css']
})
export class ChartistInvoiceComponent implements AfterViewInit {
  @Input() namess: string;

  data: any;
  dataPayment: any;
  temp: any;
  graphDataJson: any;

  graphStatData: any;
  labelsArray = [];

  invoiceSeriesArray = [];
  paymentSeriesArray = [];
  invoiceCountTotal: any;

  invoiceTotalSum: number;
  invoiceCountSum: number;

  paymentTotalSum: number;
  paymentCountSum: number;

  isLoading: boolean;

  private eventsInvSubscription: any
  @Input() eventsinv: Observable<void>;


  constructor(private http: HttpClient, private parameterData: ParameterData, private datePipe: DatePipe
    , private dataService: DataService
    , private spinnerService: Ng4LoadingSpinnerService
  ) {



  }//end const





  ngOnInit() {
    this.eventsInvSubscription = this.eventsinv.subscribe(() => this.ngAfterViewInit())
  }

  ngOnDestroy() {
    this.eventsInvSubscription.unsubscribe()
  }






  ngAfterViewInit() {

    const optionsLineChart = {

      axisX: {
        showGrid: false,

      },

      axisY: {
        offset: 65
      },
      low: 0,




      chartPadding: { top: 15, right: 5, bottom: 0, left: 0 }
      , plugins: [
        Chartist.plugins.tooltip(
          {
            textAnchor: 'middle'
            , pointClass: 'my-cool-point'
            , currency: 'Total: '
          }
        )
      ]
    };//end oprion



    //setTimeout(() => {

      this.isLoading = true;

      this.dataService.currentChartDataInvoice.subscribe(message => this.data = message)

      new Chartist.Line(
        '#chartinv',
        this.data,
        optionsLineChart

      )

        .on("draw", function (data) {

          if (data.type === "point") {
            data.element._node.setAttribute("title", "Value: " + data.value.y);
            data.element._node.setAttribute("data-chart-tooltip", "chartinv");




            var circle = new Chartist.Svg('circle', {
              cx: [data.x],
              cy: [data.y],
              r: [4],
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              class: 'my-cool-point',


            }, 'ct-area');

            data.element.replace(circle);

          }


          if (data.type === 'line' || data.type === 'area') {

            data.element.animate({
              d: {
                begin: 1000 * data.index,
                dur: 1000,
                from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                to: data.path.clone().stringify(),
                easing: Chartist.Svg.Easing.easeOutQuint
              }
            });
          }
        }).on("created", function () {

          $("#chartinv").tooltip({
            selector: '[data-chart-tooltip="chartinv"]',
            container: "#chartinv",
            html: true
          });
        });


      this.isLoading = false;


    //}, 0);




  }//ng after initview



}//end class
